export const Layout = ({style, children}) => {
    return (
      <div className="layout" style={style}>
        {children}
      </div>
    )
};

export default Layout;